define('models/pages/wishlist/offers/filter-day',['require','underscore','chaplin','models/base/model'],function(require) {
    'use strict';

    var _ = require('underscore'),
        Chaplin = require('chaplin'),
        Model = require('models/base/model');

    var FilterDay = Model.extend({
        toggleSelection: function() {
            var found;

            if (!this.get('count')) {
                return;
            }

            if (this.get('all')) {
                this.collection.without(this).forEach(function(model) {
                    model.set('active', false);
                });
                this.set('active', true);
            } else {
                this.collection.findWhere({ all: true }).set('active', false);
                found = _.find(this.collection.without(this), { active: true });
                if (!found) {
                    this.set('active', true);
                } else {
                    this.set('active', !this.get('active'));
                }
            }
        }
    });

    return FilterDay;
});

